module.exports = __webpack_public_path__ + "static/media/register.2283b7e6.jpg";